import { useAuth } from '@common/auth/use-auth';
import { useSettings } from '@ui/settings/use-settings';
import React from 'react';

export function CreditsPanel({ user }: { user: { available_credits: number } }) {

    const { hasPermission } = useAuth();
    const { api } = useSettings();

    if (!api?.integrated || !hasPermission('api.access')) return null;
    return (
        <div className="p-24 rounded shadow">
            <h2 className="text-xl font-semibold mb-16">Available Credits</h2>
            <div className="text-lg mb-16">
                <span className="font-bold">{user.available_credits}</span> credits
            </div>
            <button
                className="px-8 py-3 bg-primary-500 text-white text-lg font-medium rounded hover:bg-primary-600 transition-colors focus:outline-none"
                style={{ backgroundColor: '#3b82f6' }} // Fallback background color
                onClick={() =>
                    (window.location.href = 'https://www.folderfort.com/shop/api-credits/')
                }
            >
                Buy Credits
            </button>
        </div>
    );
}
